import { useEffect, useState } from 'react'

import RevealCardsLargeScreen from './RevealCardsLargeScreen'
import RevealCardsSmallScreen from './RevealCardsSmallScreen'
import { ScreenSizes } from '../../../utils/types'
import ReactSectionHeader from '../../ReactSectionHeader'
import { RevealCardsProps } from '../types'
import './RevealCards.scss'

const RevealCards = (props: RevealCardsProps): JSX.Element => {
  const { eyebrow, title, description, contentFragments } = props
  const [isMobileScreen, setIsMobileScreen] = useState(false)

  useEffect(() => {
    resizeRevealCards()
    window.addEventListener('resize', resizeRevealCards)

    return () => {
      window.removeEventListener('resize', resizeRevealCards)
    }
  }, [])

  const resizeRevealCards = () => {
    window.innerWidth < ScreenSizes.LG ? setIsMobileScreen(true) : setIsMobileScreen(false)
  }

  return (
    <div className='reveal__cards-container' data-testid='reveal__cards-container'>
      <ReactSectionHeader
        eyebrow={{ value: eyebrow, isRTE: true }}
        title={{ value: title, isRTE: true }}
        description={{ value: description, isRTE: true, className: 'main-description' }}
      />

      <div className='reveal__cards-wrapper' data-testid='reveal__cards-wrapper'>
        {isMobileScreen ? (
          <RevealCardsSmallScreen contentFragments={contentFragments} />
        ) : (
          <RevealCardsLargeScreen contentFragments={contentFragments} />
        )}
      </div>
    </div>
  )
}

export default RevealCards
